import React from 'react';
import { Button, Card, Text, Icon } from '@perch-labs/shrike';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Container } from 'styles';
import { copyFor } from 'config';
import { CardContent } from 'components/errors/content/content.style';
import { ErrorText } from 'components/errors/content';
import { ApolloError } from '@apollo/client';
import { StyledList } from '../dashboard.style';
import { DashboardRow } from '../dashboard-row';
import { PlansWrapper } from '../plans-wrapper';
import { downloadCSV } from './plans.util';

const getCopy = copyFor('dashboard.standardDashboard.plans');

interface Props {
  activePlansCount: number;
  accountSummaryData: {
    accountSummary: (AccountSummaryDetail | null)[];
    accountSummaryLoading: boolean;
  };
  isSMB: boolean;
  isError: ApolloError | undefined;
}
export const Plans = ({
  activePlansCount,
  accountSummaryData,
  isSMB,
  isError,
}: Props) => {
  const flags = useFlags();
  const titleCopy =
    activePlansCount > 1
      ? getCopy('title.multiPlan')
      : getCopy('title.singlePlan');

  const { accountSummaryLoading, accountSummary } = accountSummaryData;

  if (isError) {
    return (
      <Card mobileVariant="flat" margin={{ bottom: '24px' }}>
        <CardContent
          variant="primary"
          data-testid="plan-error-content"
          style={{ padding: '24px', borderRadius: '8px' }}
        >
          <Container flex direction="column" alignItems="center">
            <ErrorText variant="primary" />
          </Container>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card mobileVariant="flat" margin={{ bottom: '24px' }}>
      <Card.Header>
        <Text tag="h2" textStyle="heading700" margin={{ bottom: '16px' }}>
          {titleCopy}
        </Text>
        {isSMB && flags.lbAccountSummaryDownload && (
          <Button
            onClick={() => downloadCSV(accountSummary)}
            color="primary"
            margin={{ bottom: '16px' }}
            backgroundless
            loading={accountSummaryLoading}
          >
            <Icon icon="UIDownload" color="primary" margin={{ right: '8px' }} />
            {getCopy('downloadButton')}
          </Button>
        )}
      </Card.Header>
      <PlansWrapper status="active" count={activePlansCount}>
        {({ plans, showPagination }) => (
          <Container small={{ padding: '0 24px' }}>
            <StyledList showPagination={showPagination}>
              {plans.map(plan => (
                <DashboardRow
                  key={`dashboard-list-${plan.id}`}
                  plan={plan}
                  isSMB={isSMB}
                />
              ))}
            </StyledList>
          </Container>
        )}
      </PlansWrapper>
    </Card>
  );
};
